import React, { Component } from 'react';
import { Tabs, TabList, TabPanel, Tab } from 'react-tabs';
import {User,Settings} from 'react-feather'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class Tabset_profile extends Component {
   
    constructor(props){
        super(props)
        this.state={
            userProfile:[]
        }
    }

    componentDidMount(){
        if(!localStorage.getItem('userInfo')){
            window.location.href='/admin';
        }

        const adminuserInfo = localStorage.getItem('userInfo')
        const obj = JSON.parse(adminuserInfo)
        this.setState({userProfile:obj})
    }

    onUserUpdateHandler(e){
        e.preventDefault()
        const adminuserInfo = localStorage.getItem('userInfo')
        const obj = JSON.parse(adminuserInfo)
        const url = `${process.env['REACT_APP_HOST']}/api/users/profile/${obj._id}`;
        
		const params = {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
                firstName   : e.target.firstName.value,
                lastName    : e.target.lastName.value,
			}),
		};
        fetch(url, params)
        .then(response => response.json())
        .then(data => {
            localStorage.setItem('userInfo', JSON.stringify(data));
            toast.success("Profile updated successfully")
        })
    }

    updatePasswordHandler(e){
        e.preventDefault()
        const adminuserInfo = localStorage.getItem('userInfo')
        const obj = JSON.parse(adminuserInfo)
        const userId = obj._id;

        const pass=e.target.password.value
        const confirmPass=e.target.confirmPassword.value
        if(pass == confirmPass){
            const params={
                method:'PUT',
                headers:{
                    'Content-Type': 'application/json',
                },
                body:JSON.stringify({
                    password    : pass ,
                    oldPassword : e.target.oldPassword.value,
                    isAdmin     : true
                }),
            };
        
            fetch(`${process.env['REACT_APP_HOST']}/api/users/password/${userId}`,params)
            .then(response =>response.json())
            .then(data=>{
                if(data.msg=="success"){
                    toast.success("Password updated successfully")
                    setTimeout(() => {  
                        localStorage.removeItem('userInfo'); 
                        window.location.href='/admin';
                    }, 5000);
                }else{
                    toast.error("Old password does not match")
                }
            })
        }
        else{
            toast.error("Confirm password does not match")
        }
    }

    render() {
        
    return (
            <div>
                <Tabs>
                    <TabList className="nav nav-tabs tab-coupon" >
                        <Tab className="nav-link"><User className="mr-2" />Profile</Tab>
                        {/* <Tab className="nav-link"><Settings className="mr-2" />Contact</Tab> */}
                    </TabList>

                    <TabPanel>
                        <form method='post' onSubmit={this.onUserUpdateHandler}  className="needs-validation user-add" noValidate="">
                            <h4>Account Details</h4>
                            <div className="form-group row">
                                <label className="col-xl-3 col-md-4"><span>*</span> First Name</label>
                                <input  name="firstName" defaultValue={this.state.userProfile.firstName} className="form-control col-xl-9 col-md-8" id="validationCustom0" type="text" required="" />
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-md-4"><span>*</span> Last Name</label>
                                <input name="lastName" defaultValue={this.state.userProfile.lastName} className="form-control col-xl-9 col-md-8" id="validationCustom1" type="text" required="" />
                            </div>
                            <div className="form-group row">
                                <div className="col-md-12 text-right pr-0">
                                      <button type="submit" className="btn btn-primary">Update</button>
                                </div>
                               
                            </div>
                            <br />
                        </form>

                        <form method='post' onSubmit={this.updatePasswordHandler}  className="needs-validation user-add" noValidate="">
                            <h4>Change Password</h4>
                            
                            <div className="form-group row">
                                <label className="col-xl-3 col-md-4"><span>*</span> Old Password</label>
                                <input name="oldPassword"  className="form-control col-xl-9 col-md-8" id="validationCustom2" type="text" required="" />
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-md-4"><span>*</span> Password</label>
                                <input  name="password" className="form-control col-xl-9 col-md-8" id="validationCustom3" type="password" required="" />
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-md-4"><span>*</span> Confirm Password</label>
                                <input name="confirmPassword" className="form-control col-xl-9 col-md-8" id="validationCustom4" type="password" required="" />
                            </div>
                            <div className="form-group row">
                                <div className="col-md-12 text-right pr-0">
                                      <button type="submit" className="btn btn-primary">Update</button>
                                </div>
                            </div>
                        </form>
                    </TabPanel>   
                </Tabs>
             <ToastContainer />
            </div>
        )
    }
}

export default Tabset_profile
